<template>
  <div id="listContentCom">
    <div class="listContent" :class="{ listContent_active: flag }">
      <div v-if="total > 0 && lists.length > 0">
        <van-checkbox-group v-model="result" @change="toggle">
          <van-cell-group>
            <van-cell v-for="list in lists" :key="list.docid">
              <template #title>
                <div
                  @click="wordDetail(list)"
                  v-html="list.fname"
                  class="doctitle"
                ></div>
                <!-- <div v-else v-html="list.fname" class="doctitle"></div> -->
              </template>
              
              <template #label>
                <template v-if="$route.path !='/judgeCase' &&
                  $route.path !='/taxCase' && $route.path !='/taxForm'"> 
                  <div class="msgContent" v-if="currentType == 1">
                    <div class="time">{{ list.fcode }} {{ list.pdate }}</div>
                    <div class="tag">
                      <span class="tag">{{ list.potence }}</span>
                    </div>
                  </div>
                  <div class="msgContent" v-else>
                    <div class="time">{{ list.psource }}</div>
                    <div class="tag">
                      <span class="tag">{{ list.pdate }}</span>
                    </div>
                  </div>
                </template>
                <template v-if="$route.path=='/judgeCase'">
                  <div class="msgContent">
                    <div class="time">{{parseTime(list.pbdate)}}</div>
                    <div class="tag">
                      <span class="tag">{{ list.court }}</span>
                    </div>
                  </div>
                </template>
                <template v-if="$route.path =='/taxCase'">
                  <div class="msgContent">
                    <div class="time">{{list.author}}</div>
                    <div class="tag">
                      <span class="tag" v-if="list.reporter">{{ list.reporter }}</span>
                    </div>
                  </div>
                </template>
                <template v-if="$route.path =='/taxForm'">
                  <div class="msgContent">
                    <div class="time">{{list.fcode}}</div>
                    <div class="tag">
                      <span @click="findOrigin(list)">查阅主文件</span>
                      <span class="tag" @click="formDown()">下载</span>
                    </div>
                  </div>
                </template>
              </template>
              <template #right-icon>
                <van-checkbox v-if="flag" :name="list.docid" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
      <div v-else-if="lockLists.length > 0">
        <van-checkbox-group v-model="result" @change="toggle">
          <van-cell-group>
            <van-cell v-for="list in lockLists" :key="list.docid">
              <template #title>
                <div
                  @click="wordDetail(list)"
                  v-html="list.fname"
                  class="doctitle"
                ></div>
              </template>
              <template #label>
                <div class="msgContent">
                  <div class="time">{{ list.fcode }} {{ list.pdate }}</div>
                  <div class="tag">
                    <span class="tag">{{ list.potence }}</span>
                  </div>
                </div>
              </template>
              <template #right-icon>
                <van-checkbox v-if="flag" :name="list.docid" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
      <div
        v-else-if="
          doubleLists && (commonLists.length > 0 || industryLists.length > 0)
        "
      >
        <van-tabs
          v-model="active"
          @change="changeTabs"
          color="#1989FA"
          title-active-color="#1989FA"
          line-width="80"
        >
          <van-tab title="通用规定">
            <div v-if="commonLists.length > 0">
              <van-checkbox-group v-model="result" @change="toggle">
                <van-cell-group>
                  <van-cell v-for="list in commonLists" :key="list.docid">
                    <template #title>
                      <div
                        @click="wordDetail(list)"
                        v-html="list.fname"
                        class="doctitle"
                      ></div>
                    </template>
                    <template #label>
                      <div class="msgContent">
                        <div class="time">
                          {{ list.fcode }} {{ list.pdate }}
                        </div>
                        <div class="tag">
                          <span class="tag">{{ list.potence }}</span>
                        </div>
                      </div>
                    </template>
                    <template #right-icon>
                      <van-checkbox
                        v-if="flag"
                        :name="list.docid"
                        ref="checkboxes"
                      />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
            <div v-else>
              <div class="noDatas ">
                <!-- <van-empty description="暂无数据" /> -->
              </div>
            </div>
          </van-tab>
          <van-tab v-if="countries" title="国家(地区)">
            <div v-if="industryLists.length > 0">
              <van-checkbox-group v-model="result" @change="toggle">
                <van-cell-group>
                  <van-cell v-for="list in industryLists" :key="list.docid">
                    <template #title>
                      <div
                        @click="wordDetail(list)"
                        v-html="list.fname"
                        class="doctitle"
                      ></div>
                    </template>
                    <template #label>
                      <div class="msgContent">
                        <div class="time">
                          {{ list.fcode }} {{ list.pdate }}
                        </div>
                        <div class="tag">
                          <span class="tag">{{ list.potence }}</span>
                        </div>
                      </div>
                    </template>
                    <template #right-icon>
                      <van-checkbox
                        v-if="flag"
                        :name="list.docid"
                        ref="checkboxes"
                      />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
            <div v-else>
              <div class="noDatas">
                <!-- <van-empty description="暂无数据" /> -->
              </div>
            </div>
          </van-tab>
          <van-tab v-else title="专属规定">
            <div v-if="industryLists.length > 0">
              <van-checkbox-group v-model="result" @change="toggle">
                <van-cell-group>
                  <van-cell v-for="list in industryLists" :key="list.docid">
                    <template #title>
                      <div
                        @click="wordDetail(list)"
                        v-html="list.fname"
                        class="doctitle"
                      ></div>
                    </template>
                    <template #label>
                      <div class="msgContent">
                        <div class="time">
                          {{ list.fcode }} {{ list.pdate }}
                        </div>
                        <div class="tag">
                          <span class="tag">{{ list.potence }}</span>
                        </div>
                      </div>
                    </template>
                    <template #right-icon>
                      <van-checkbox
                        v-if="flag"
                        :name="list.docid"
                        ref="checkboxes"
                      />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
            <div v-else>
              <div class="noDatas">
                <!-- <van-empty description="暂无数据" /> -->
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <div
        v-else-if="
          place &&
            (provinceLists.length > 0 ||
              cityLists.length > 0 ||
              globalLists.length > 0)
        "
      >
        <van-tabs
          v-model="activePlace"
          @change="changeTabsPlace"
          color="#1989FA"
          title-active-color="#1989FA"
          line-width="30"
        >
          <van-tab :title="'中央(' + totalLists + ')'">
            <div v-if="globalLists.length > 0">
              <van-checkbox-group v-model="result" @change="toggle">
                <van-cell-group>
                  <van-cell v-for="list in globalLists" :key="list.docid">
                    <template #title>
                      <div
                        @click="wordDetail(list)"
                        v-html="list.fname"
                        class="doctitle"
                      ></div>
                    </template>
                    <template #label>
                      <div class="msgContent" v-if="$route.path!='/answer'">
                        <div class="time">
                          {{ list.fcode }} {{ list.pdate }}
                        </div>
                        <div class="tag">
                          <span class="tag">{{ list.potence }}</span>
                        </div>
                      </div>
                      <div class="msgContent" v-else>
                        <div class="time">{{ list.psource }}</div>
                        <div class="tag">
                          <span class="tag">{{ list.pdate }}</span>
                        </div>
                      </div>
                    </template>
                    <template #right-icon>
                      <van-checkbox
                        v-if="flag"
                        :name="list.docid"
                        ref="checkboxes"
                      />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
            <div v-else>
              <div class="noDatas">
                <!-- <van-empty description="暂无数据" /> -->
              </div>
            </div>
          </van-tab>
          <van-tab
            v-if="
              valueP !== '' &&
                valueP !== null &&
                valueProvCode !== '' &&
                valueProvCode !== null
            "
            :title="valueP + '(' + totalLists1 + ')'"
          >
            <div v-if="provinceLists.length > 0">
              <van-checkbox-group v-model="result" @change="toggle">
                <van-cell-group>
                  <van-cell v-for="list in provinceLists" :key="list.docid">
                    <template #title>
                      <div
                        @click="wordDetail(list)"
                        v-html="list.fname"
                        class="doctitle"
                      ></div>
                    </template>
                    <template #label>
                      <div class="msgContent" v-if="$route.path!='/answer'">
                        <div class="time">
                          {{ list.fcode }} {{ list.pdate }}
                        </div>
                        <div class="tag">
                          <span class="tag">{{ list.potence }}</span>
                        </div>
                      </div>
                      <div class="msgContent" v-else>
                        <div class="time">{{ list.psource }}</div>
                        <div class="tag">
                          <span class="tag">{{ list.pdate }}</span>
                        </div>
                      </div>
                      
                    </template>
                    <template #right-icon>
                      <van-checkbox
                        v-if="flag"
                        :name="list.docid"
                        ref="checkboxes"
                      />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
            <div v-else>
              <div class="noDatas">
                <!-- <van-empty description="暂无数据" /> -->
              </div>
            </div>
          </van-tab>

          <van-tab
            v-if="
              $route.path!='/answer' &&
              valueC !== '' &&
                valueC !== null &&
                valueCityCode !== '' &&
                valueCityCode !== null
            "
            :title="valueC + '(' + totalLists2 + ')'"
          >
            <div v-if="cityLists.length > 0">
              <van-checkbox-group v-model="result" @change="toggle">
                <van-cell-group>
                  <van-cell v-for="list in cityLists" :key="list.docid">
                    <template #title>
                      <div
                        @click="wordDetail(list)"
                        v-html="list.fname"
                        class="doctitle"
                      ></div>
                    </template>
                    <template #label>
                      <div class="msgContent">
                        <div class="time">
                          {{ list.fcode }} {{ list.pdate }}
                        </div>
                        <div class="tag">
                          <span class="tag">{{ list.potence }}</span>
                        </div>
                      </div>
                    </template>
                    <template #right-icon>
                      <van-checkbox
                        v-if="flag"
                        :name="list.docid"
                        ref="checkboxes"
                      />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
            <div v-else>
              <div class="noDatas">
                <!-- <van-empty description="暂无数据" /> -->
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <div v-else>
        <div class="noDatas">
          <!-- <van-empty description="暂无数据" v-if="searchBG === ''" /> -->
          <!-- v-else -->
          <van-empty
            class="custom-image"
            :image="searchBG"
            :description="currentType == 1 ? '搜索文件': '搜索解答'"
            v-if="$route.path === '/newSearchEngine'"
          />
        </div>
      </div>
    </div>
    <!-- 弹框详情 -->
    <van-popup
      v-model="showDetailPopup"
      position="right"
      :style="{ height: '100%', width: '100%' }"
    >
     <audio id="video-player" :src="audioLink" style="visibility:hidden">
        您的浏览器不支持audio元素。
      </audio>
      <Speecher
        ref="speech"
        :speechPause="speechPause"
        @playAudio="playAudio"
        @pauseAudio="pauseAudio"
        @resetAudio="resetAudio">
      </Speecher>
      
      <div class="fileElements">
        <div class="docContent" id="moreMerchant">
          <van-collapse class="collapse-box" v-model="activeColl"  v-if="shareScene == 'paperword' ||shareScene == 'taxnews'" >
            <van-collapse-item  :title="shareScene != 'taxnews' ? '判例要素' : '案例要素'" name="1" >
              <div class="elements topLine">
                <div class="title" v-if="shareScene!= 'taxnews'">判例要素</div>
                <div class="title" v-else>案例要素</div>
                <div class="content">内容</div>
              </div>
              <div class="elements"
                v-for="(item, index) in headers"
                :key="index">
                <div class="title" v-html="item.t"></div>
                <div class="content" v-html="item.v" @click="open"></div>
              </div>
            </van-collapse-item>
          </van-collapse>
          <van-collapse class="collapse-box" v-model="activeNames" v-if="shareScene == 'policy' ||shareScene == 'answer'">
            <van-collapse-item  :title="shareScene == 'policy' ? '文件要素' : '解答要素'" name="1">
              <div class="elements topLine">
                <div class="title" v-if="shareScene!= 'answer'">文件要素</div>
                <div class="title" v-else>解答要素</div>
                <div class="content">内容</div>
              </div>
              <div
                class="elements"
                v-for="(item, index) in headers"
                :key="index"
              >
                <div class="title" v-html="item.t"></div>
                <div class="content" v-html="item.v" @click="open"></div>
              </div>
            </van-collapse-item>
          </van-collapse>
          
          <div
            class="detail defaultFont"
            v-html="value"
            style="background: #F8F8F9; padding: 10px 10px 20px 10px"
            @click="open"
          ></div>
          <div v-if="!wxgenerateid && !userId" class="loginBtn">
            <van-button type="primary" @click="login">登录/注册</van-button>
          </div>
        </div>
      </div>
      <van-tabbar :border="false">
        <div
          v-if="activeName === 'c'"
          class="backStyle"
          style="
            background-color: #fff;
            diaplay: flex;
            justify-content: space-around;
            align-items: center;
          "
        >
          <div class="oprate-box"
              @click="backToLastFire">
            <van-image width="16" height="16" :src="lastFlag ? returnImgUn: returnImg" />
            <span class="custom-title" :class="lastFlag? 'no-return': ''">返回</span>
          </div>
          <div class="oprate-box" @click="backToMail">
            <van-image width="15" height="15" :src="closeImg" />
            <span class="custom-title">关闭</span>
          </div>
        </div>
        <div
          v-else
          class="backStyle"
          style="background-color: #fff; diaplay: flex; align-items: center"
        >
          <div class="oprate-box"
            @click="backToLastFire">
            <van-image width="16" height="16" :src="lastFlag  ? returnImgUn: returnImg" />
             <span class="custom-title" :class="lastFlag? 'no-return': ''">返回</span>
          </div>
          <div class="oprate-box" @click="backToMail">
            <van-image width="15" height="15" :src="closeImg" />
            <span class="custom-title">关闭</span>
          </div>
          <div class="oprate-box" @click="showMailPop = true">
            <van-image width="16" height="13" :src="mailImg" />
            <span class="custom-title">邮箱</span>
          </div>
          <div class="oprate-box" 
              v-if="shareScene == 'policy' && currentType == 1"  @click="uploadToSmartCloud">
            <van-image width="18" height="13" :src="cloudImg" />
            <span class="custom-title cloud-title">上传云端</span>
          </div>
          <van-button
            :icon="shareImg"
            class="share-btn"
            @click="shareBtn"
            >分享
          </van-button>
          <!-- v-if="isWx" -->
        </div>
      </van-tabbar>
    </van-popup>

    <van-popup
      v-model="showMailPop"
      position="bottom"
      closeable
      round
      style="width:100%; height:40%"
    >
      <div class="send-mail-wapper">
        <h3 style="text-align:center">发送文件到邮箱</h3>
        <div class="mail-box">
          <span>邮箱:</span>
          <van-field
            v-model="mailText"
            placeholder="请输入您的邮箱"
            :error-message="errMsg.mailText"
          />
        </div>
        <van-button
          :disabled="!mailText"
          style="width:100%;border-radius: 30px;height: 40px;"
          type="info"
          @click="sureSendMail"
          >确定</van-button
        >
      </div>
    </van-popup>
    <!-- 登录 -->
    <login ref="alertModel" @updateDoc="updateDoc" @refreshProtect="refreshProtect"></login>

    <!-- 一键上传 -->
    <upload-file :uploadDocId="uploadDocId" ref="uploadFile"></upload-file>

    <!-- <van-overlay :showLoding="showLoding"></van-overlay> -->
    <van-overlay
      :show="showLoding"
      @click="showLoding = false"
      z-index="9999"
      :custom-style="{ backgroundColor: 'rgba(255, 255, 255, .8)' }"
    >
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" color="#1989fa"></van-loading>
      </div>
    </van-overlay>

    <!-- 分享指引 -->
    <div class="share-img-container">
      <van-popup
        v-model="shareImgShow"
        style="width:100%; height:100%"
        duration="0"
      >
        <div @click="closeShareImg" style="height:100%">
          <div class="share-img-box">
            <img 
            src="../../../assets/share/jiantou.png" alt="" />
          </div>
          <div class="share-content">
            点击右上角将文章分享给朋友
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>


<script>

import UploadFile from "@/components/common/uploadFile"; // 一键上传
import Speecher from "@/components/speecher"; // 一键上传
import { base } from "@/utils/lib/util.js";
import Login from "@/components/common/login";
import { commonNotify, warningNotify, commonDialog } from "@/utils/lib/toast";
import { host } from "../../../../public/config.json";
import { wxConfig } from "@/utils/newLibs/getWxOptions.js";
import { getUrlParam} from "@/utils/lib/searchtoobj.js";
import { parseTime } from '@/utils/time.js';
//const speaech = new SpeechSynthesisUtterance()

export default {
  props: {
    lists: {
      type: Array,
      default: function() {
        return [];
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    totalLists: {
      type: Number,
      default: 0,
    },
    totalLists1: {
      type: Number,
      default: 0,
    },
    totalLists2: {
      type: Number,
      default: 0,
    },
    lockLists: {
      type: Array,
      default: function() {
        return [];
      },
    },
    doubleLists: {
      type: Boolean,
      default: false,
    },
    countries: {
      type: Boolean,
      default: false,
    },
    commonLists: {
      // 通用规定
      type: Array,
      default: function() {
        return [];
      },
    },
    industryLists: {
      // 专属规定
      type: Array,
      default: function() {
        return [];
      },
    },
    provinceLists: {
      // 省份
      type: Array,
      default: function() {
        return [];
      },
    },
    cityLists: {
      // 城市
      type: Array,
      default: function() {
        return [];
      },
    },
    globalLists: {
      // 全国
      type: Array,
      default: function() {
        return [];
      },
    },
    place: {
      type: Boolean,
      default: true,
    },
    searchBG: {
      type: String,
      default: "",
    }
  },
  components: {
    Login,
    UploadFile,
    Speecher
  },
  computed: {
    loginWay() {
      return this.$store.state.changeSomeThing.loginWay;
    },
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    userId() {
      return this.$store.state.user.userId;
    },
    valueP() {
      return this.$store.state.commonSearchData.valueP;
    },
    valueProvCode() {
      return this.$store.state.commonSearchData.valueProvCode;
    },
    valueC() {
      return this.$store.state.commonSearchData.valueC;
    },
    valueCityCode() {
      return this.$store.state.commonSearchData.valueCityCode;
    },
    fixedDir() {
      return this.$store.state.fixedFolder.fixedFolderArr;
    },
    activeName() {
      return this.$store.state.commonSearchData.activeName;
    },
    accountstatus() {
      return this.$store.state.user.accountstatus;
    },
    isProtect() {
      return this.$store.state.search.isProtect;
    },
    warningLevel() {
      return this.$store.state.search.warningLevel;
    },
    warningText() {
      return this.$store.state.search.warningText;
    },
    isWx() {
      return localStorage.getItem("WX_VERSION") === "1";
    },
    accounttype () {
      return this.$store.state.user.accounttype;
    },
    shareTypeVal() {
      if (this.shareType === 1) {
        return '👮最新政策发布'
      } else if (this.shareType === 2) {
        return '👮税收优惠政策'
      } else if (this.shareType === 3) {
        return '👮官方解答'
      } else if (this.shareType === 4) {
        return '👮涉税判例'
      } else if (this.shareType === 5) {
        return '👮税务案例'
      } else {
        return '👮税收政策法规'
      }
    }
  },
  data() {
    return {
      showDetailPopup: false, // 弹出框
      show: true,
      activeNames: ["1"],
      activeColl: ["1"],
      headers: [], // 文件要素
      value: "", // 文件正文内容
      showLoginBtn: false,
      active: this.$store.state.commonSearchData.active,
      activePlace: this.$store.state.commonSearchData.activePlace,
      result: [],
      flag: false,
      backDocFiresArr: [], // 返回的文件docid
      lastFlag: true,
      loginDocId: "", // 点击的doc的文件内容
      loginDoc: {}, // 点击的doc的文件内容
      showLoding: false,
      addid: true, // 为true的时候添加id进数组
      uploadDocId: [], // 需要上传的docid
      shareImgShow: false,
      shareToken: "", // 分享token
      currentType: 1,
      shareLink: '', // 分享链接
      toShareTit: '',  //分享文章标题
      shareType: 0, //分享的文件类型
      shareTitle: '', //分享的文件标题
      shareScene: '', //分享场景
      returnImg: require("../../../assets/index/return_img.png"),
      returnImgUn: require("../../../assets/index/return_un_img.png"),
      closeImg: require("../../../assets/index/close_img.png"),
      shareImg: require("../../../assets/index/share_img.png"),
      cloudImg: require("../../../assets/index/cloud_img.png"),
      mailImg: require("../../../assets/index/mail.png"),
      speechPause: false,
      speechValue: '',
      speaech: '',
      flow: 0,
      audioLink: '',
      showSpeecher: true,
      showMailPop: false, //展示邮件弹窗
      mailPattern: /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/,
      mailText: '',
      errMsg: {
        mailText: ''
      }
    };
  },
  created() {
    this.showSpeecher =  false
  },
  methods: {
    // 传至政策匹配页父组件
    refreshProtect() {
      this.$emit('refreshProtect')
    },
    // 表单下载
    formDown() {
      this.$notify({
        color: "#fff",
        background: "#F27852",
        message: `请至电脑端进行下载`,
        duration: 3000,
        });
    },
    findOrigin(e) {
      let originDoc = e
      originDoc.strdocid = e.masterdocidstr
      this.getDetail(originDoc)
    },
    // 获取当前文件的语音链接
    getAudioLink(strId){
      this.$http.ReqGetTTs(strId).then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            this.audioLink = res.item.signedurl
            this.flow = res.item.filesize
            this.speechPause = false
          } else if(res.rltcode === -160) {
            this.audioLink = ''
          }
        }
      });
    },
    playAudio(){
      if(this.audioLink) {
        this.$refs.speech.isPlaying = true
        this.speechPause = false
        this.$notify({
        color: "#fff",
        background: "#49d68c",
        message: `将使用${(this.flow/1024/1024).toFixed(2)}MB流量`,
        duration: 3000,
        });
        var audio = document.getElementById('video-player');
        audio.play()
        audio.addEventListener('ended', () => {
          this.speechPause = true
          //console.log('jjj', this.speechPause)
        })
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: '该文件语音正在生成中，请稍后再试',
          duration: 5000,
        })
        return false
      }
      
    },
    pauseAudio() {
      if (this.speechPause) {
        document.getElementById('video-player').play()
        this.speechPause = false
      } else {
        document.getElementById('video-player').pause()
        this.speechPause = true
      }
    },
    resetAudio() {
      this.$refs.speech.isPlaying = false
      var audio = document.getElementById('video-player');
      audio.currentTime = 0
      audio.pause()
    },
    sureSendMail() {
      let strId;
      if (this.backDocFiresArr.length > 1) {
        strId = this.loginDocId
      } else {
        strId = this.loginDoc.strdocid
      }
      if(!this.mailPattern.test(this.mailText)) {
        this.errMsg.mailText = "邮箱输入有误，请重新输入";
        return false;
      } else {
        this.errMsg.mailText = "";
        this.$http.reqSendMail({
          strdocid: strId,
          email: this.mailText
        }).then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
               this.$notify({
                color: "#fff",
                background: "#49d68c",
                message: '邮件发送成功',
                duration: 3000,
              })
              this.showMailPop = false
            } else {
              this.$notify({
                color: "#fff",
                background: "#F27852",
                message: res.rltdesc,
                duration: 3000,
              })
            }
          }
        })
      }
    },
    // 点击分享获取链接
    shareBtn() {
      this.getShareLink()
    },
    // 时间戳转化
    parseTime(time) {
      return parseTime(time, '{y}年{m}月{d}日')
    },
    // 获取分享链接
    getShareLink() {
      let docid;
      if(this.backDocFiresArr.length > 1) {
        docid = this.loginDocId
      } else {
        docid = this.loginDoc.strdocid
      }
      let bodyJson = {
        docid: docid
      };
      this.$http.reqGetShareUrl(bodyJson).then((res) => {
        this.shareLink = res.item.url
        if(this.shareLink) {
          window.location.href = this.shareLink
          localStorage.setItem("shareWay",1)
          window.localStorage.removeItem("docFiresArr")
        }
      });
    },
    setCurrentType (e) {
      this.currentType = e
    },
    toggle(names) {
      this.result = names;
      this.$store.commit("choose/setResult", this.result);
    },
    changeFlag() {
      this.flag = true;
    },
    changeFlag2() {
      this.flag = false;
    },
    // 切换标签
    changeTabs(name, title) {
      console.log("name, title", name, title);
      this.$store.commit("commonSearchData/changeActive", name);
      if (name === 0 && title === "通用规定") {
        this.$emit("changeCommonFlag");
      } else if (name === 1 && title === "专属规定") {
        this.$emit("changeIndustryFlag");
      } else if (name === 1 && title === "国家(地区)") {
        this.$emit("changeIndustryFlag");
      }
    },
    // 切换地方版 省份 城市 中央标签
    changeTabsPlace(name, title) {
      console.log("name, title", name, title);
      this.activePlace = name;
      this.$store.commit("commonSearchData/changeActivePlace", name);
      if (name === 0) {
        this.$emit("changeGlobalFlag");
        return;
      }

      if (name === 1) {
        this.$emit("changeProvinceFlag");
        return;
      }

      if (name === 2) {
        this.$emit("changeCityFlag");
        return;
      }
    },
    // 返回按钮
    backToLastFire() {
      this.resetAudio()
      if(this.lastFlag) {
        return
      }
      this.$nextTick(() => {
        let dom =document.getElementById("moreMerchant");
        dom.scrollIntoView()
      });
      this.addid = false;
      if (this.backDocFiresArr.length > 1) {
        this.backDocFiresArr.pop();
        //console.log("返回按钮backDocFiresAr", this.backDocFiresArr);
        let lastId = this.backDocFiresArr.slice(-1);
        this.getDetail1(lastId[0]);
        if (this.backDocFiresArr.length === 1) {
          this.lastFlag = true;
        }
        this.$http.reqCloseDoc(lastId).then((res) => {
          console.log("guanbiwen ", res);
        });
      } else {
        // 只有一个id
        this.getDetail1(this.backDocFiresArr[0]);
        this.lastFlag = true;
        
      }
    },
    // 关闭按钮
    backToMail() {
      this.resetAudio()
      this.$nextTick(() => {
        let dom = document.getElementById("moreMerchant");
        dom.scrollIntoView();
      });
      this.addid = true;
      this.showDetailPopup = false;
      let reqDocFiresArr = this.backDocFiresArr.concat([]);
      
      this.$http.reqCloseDoc(reqDocFiresArr).then((res) => {
        console.log("guanbiwen ", res);
      });
      this.backDocFiresArr = [];
    },
    // 上传云端按钮
    uploadToSmartCloud() {
      if (this.userId) {
        this.$refs.uploadFile.updateOrDelete(1, '上传云端');
        console.log("直接上传的id", this.uploadDocId, this.fixedDir[0].dir_id);
      } else {
        // 提示登录后使用
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请您先登录再使用[上传云端]功能",
          duration: 5000,
        });
      }
    },

    // 更新doc文件的内容
    updateDoc() {
      if (this.backDocFiresArr.length > 1) {
        this.getDetail1(this.loginDocId);
      } else {
        this.getDetail(this.loginDoc);
      }
    },

    // 点击列表查看详情
    wordDetail(doc) {
      if(this.$route.path =='/taxForm'){
        this.showLoding = false;
        return false
      }
      if (this.isProtect) {
        if(this.warningLevel == 1) {
          this.$refs.alertModel.changeShowLogin(true);
          this.$notify({
            message: "请先登录",
            type: "warning",
            duration: 5000,
          })
          return
        }
      }
      this.loginDoc = doc;
      this.lastFlag = true;

      this.uploadDocId[0] = doc.docid;

      this.getDetail(doc);
    },
    // 获取最新文件列表
    getDetail(doc) {
      this.showLoding = true;
      let bodyJson = {
        strdocid: doc.strdocid,
        docid: "",
        h1hit: doc.h1hit ? doc.h1hit : [],
        chit: doc.chit ? doc.chit : [],
        chitseq: doc.chitseq ? doc.chitseq : [],
        cutwords: [],
      };
      this.$http
        .reqPostDocDetail(bodyJson)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              this.showDetailPopup = true;
              this.loginDoc.strdocid = response.item.strdocid
              this.getAudioLink(response.item.strdocid)
              // +++
              // +++
              this.handleLoadDoc(response);
              this.setShareInfo();
            } else if(response.rltcode === -300) {
              return false
            } else {
              this.$notify({  
                color: "#fff",
                background: "#F27852",
                message: response.rltdesc,
                duration: 5000,
              });
              this.showLoding = false;
              // this.showDetailPopup = false;
            }
            if (response.rltcode === -1030) {
                this.$dialog
                .confirm({
                  title: "提示",
                  message: "要增加文件阅读上限次数,请前去“在线商城”升级至专业版服务",
                  confirmButtonText: "在线商城",
                  cancelButtonText: "取消",
                })
                .then(() => {
                  this.$router.push("/onlineMall");
                })
                .catch((err) => {
                  console.log(err);
                })
              this.showLoding = false;
            }
          } else {
            this.showLoding = false;
          }
        })
        .catch(() => {
          //sessionStorage.clear();
          //this.$cookie.delete("cookieObj");
          this.showLoding = false;
        });
    },

    getDetail1(docid) {
      this.showLoding = true;
      let bodyJson = {
        strdocid: docid,
        docid: "",
        h1hit: [],
        chit: [],
        chitseq: [],
        cutwords: [],
      };
      this.$http
        .reqPostDocDetail(bodyJson)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              this.handleLoadDoc(response);
              this.uploadDocId[0] = response.item.docid;
              this.getAudioLink(response.item.strdocid)
              
            } else {
              this.$notify({
                color: "#fff",
                background: "#F27852",
                message: response.rltdesc,
                duration: 5000,
              });
              this.showLoding = false;
            }
            if (response.rltcode === -300) {
              // 该文件需要下载才能访问，请请求下载接口
              //message: "该文件暂时无法访问，请阅览其他文件！",
              this.$notify({
                color: "#fff",
                background: "#F27852",
                message: "请登录电脑端下载该附件!   网址：www.holywiser.com",
                duration: 5000,
              });
              this.showLoding = false;
            } 
            if (response.rltcode === -1030) {
                this.$dialog
                .confirm({
                  title: "提示",
                  message: "要增加文件阅读上限次数,请前去“在线商城”升级至专业版服务",
                  confirmButtonText: "在线商城",
                  cancelButtonText: "取消",
                })
                .then(() => {
                  this.$router.push("/onlineMall");
                })
                .catch((err) => {
                  console.log(err);
                })
              this.showLoding = false;
            }
            if (this.accountstatus < 200) {
              // 该文件需要购买会员
              this.$notify({
                color: "#fff",
                background: "#F27852",
                message: "要获得普通下载权限,请前去在线商城购买账号等级",
                duration: 5000,
              });
              this.showLoding = false;
              return;
            }
          } else {
            this.showLoding = false;
          }
        })
        .catch(() => {
          this.showDetailPopup = false;
          this.showLoding = false;
        });
    },
    // 点击详情里面的链接 跳转相应的页面
    open(value) {
      this.resetAudio()
      if (value.srcElement.id) {
        this.addid = true;
        this.showLoding = true;
        this.loginDocId = value.srcElement.id;
        this.$nextTick(() => {
          let dom = document.getElementById("moreMerchant");
          dom.scrollIntoView();
        });
        this.getDetail1(value.srcElement.id);
      } else if (value.srcElement.tagName === "TT") {
        this.$nextTick(() => {
          let dom = document.getElementById(value.srcElement.lang);
          dom.scrollIntoView();
        });
        this.showLoding = false;
      }
    },
    // 显示文件详情
    handleLoadDoc(response) {
      if (response.rtncode === 1) {
        if (response.rltcode === 1) {
          this.shareType = response.item.sharetype
          this.shareScene =  response.item.scene
          localStorage.setItem('shareScene', this.shareScene)
          localStorage.setItem('shareTypeVal', this.shareTypeVal)
          this.shareTitle = response.item.doctitle
          localStorage.setItem('shareTitle', this.shareTitle)
          this.toShareTit = response.item.fname
          if (this.addid) {
            this.backDocFiresArr.push(response.item.strdocid);
            if (this.backDocFiresArr.length > 1) {
              this.lastFlag = false;
            } else {
              this.lastFlag = true;
            }
          }

          this.showLoding = false;
          this.headers = response.item.headers;
          let tempdata = base.b64_to_utf8(response.item.body);
          this.value = tempdata.replace(/\r?\n/g, "<br />")
          this.speechValue = tempdata.replace(/<[^>]+>/g, '')
          if (response.item.hidden === true) {
            // true：临时登录  false：已登录
            this.showLoginBtn = true;
          }
        } else {
          this.$notify({
            color: "#fff",
            background: "#F27852",
            message: response.rltdesc,
            duration: 5000,
          });
          this.showLoding = false;
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: response.rtndesc,
          duration: 5000,
        });
        this.showLoding = false;
      }
    },
    // 请登录查看全文 按钮
    login() {
      this.$refs.alertModel.changeShowLogin(true);
    },

    // 关闭分享指引
    closeShareImg() {
      this.shareImgShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
@--line-color: #dcdee2;

#listContentCom {
  .share-btn {
    width: 3rem;
    border-radius: 30px;
    height: 40px;
    border-color: #00A7FA;
    background: linear-gradient(to right, #00A9FF, #0080FF);
    color: #ffffff;
  }
  .fileElements {
    height: 100%;
    background: #fff;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none; // 重点
    }
    .topLine {
      border-top: 1px solid @--line-color;
    }
    .elements {
      display: flex;
      min-height: 40px;
      border-bottom: 1px solid @--line-color;
      color: #515a6e;
      font-size: 12px;
      border-right: 1px solid @--line-color;
      &:nth-child(odd) {
        background-color: #f8f8f9;
      }
      .title {
        flex: 0 0 27%;
        text-align: center;
        border-left: 1px solid @--line-color;
        border-right: 1px solid @--line-color;
        line-height: 40px;
      }
      .content {
        flex: 1;
        text-align: center;
        // border-right: 1px solid @--line-color;
        margin: auto 0;
      }
    }
    .docContent {
      margin-bottom: 60px;
      
    }
    
  }
  .oprate-box {
    padding:5px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .custom-title {
      margin-top: 1px;
    }
    .no-return {
      color: #999999;
    }
  }
  .backStyle {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .loginBtn {
    height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: -210px;
    background: rgba(255, 255, 255, 0.9);
  }
  .listContent_active {
    margin-bottom: 20px;
    // .doctitle {
    //   width: 315px;
    // }
    .msgContent {
      width: 315px;
      font-size: 12px;
      color: #a6a6a6;
      display: flex;
      justify-content: space-between;
      .time {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .tag {
        min-width: 50px;
        margin-left: 4px;
        .tag {
          width: 100%;
          color: #60d75f;
        }
      }
    }
  }
  .send-mail-wapper {
    padding: 0 20px;
    .mail-box {
      margin: 20px 0 30px 0;
      /deep/.van-cell {
        border-bottom:1px solid #F0F0F0;
        padding-left: 0px;
      }
      
    }
  }
  /deep/.van-popup__close-icon {
    color: #000;
  }
}
</style>

<style lang="less">
@import "~@/styles/article.less";
.collapse-box {
  .van-cell__title {
    color: #0084FF;
  }
  .van-cell {
    background: #F8F8F9;
  }
  .van-collapse-item__content {
    background: #F8F8F9;
  }
}
// .van-cell__title {
//   color: #0084FF;
// }

</style>
<style lang="less" scoped>
/deep/.van-tab__text {
  color: #262626;
}
/deep/.van-tab--active {
  .van-tab__text {
    color: #1F1F1F;
  }
}
</style>
